import { Webhook } from 'lucide-react';
import type { NavItem } from './types';

/**
 * The «Webhooks» destination (§4.12): «Suscripciones» (32), «Entregas
 * fallidas» (33) and «Historial de eventos» (34). The last two used to be
 * «Entregas y DLQ» and «Log de eventos»; DLQ and «log» are words for whoever
 * runs the queue, not for whoever reads the menu.
 *
 * Now that `webhooks.routes.tsx` resolves all three routes, this destination
 * stops being the provisional leaf view 32 left behind (see its comment, now
 * superseded) and becomes ONE first-level `NavItem` with `children`. An item
 * WITH children does not navigate, it expands (`types.ts`): which is why there
 * are no longer three loose first-level entries, and `to` on the parent node —
 * as in `dtes.nav.ts` — is not used to navigate; only `router.test.tsx` uses it
 * (which does not demand the parent be reachable, it demands EVERY child is)
 * and as a fallback value should `AppShell` ever need one.
 *
 * The «Entregas fallidas» `badge` §4.12 asks for is not filled here: the count
 * comes from `useListWebhookDeliveriesQuery({ status: 'dead' })`, that is from
 * a hook, and this module is a module-level constant. `AppLayout` attaches it
 * onto this tree, via `nav/use-nav-badges.ts` — where it is also noted that
 * this counter SATURATES, because the endpoint returns an array with a `limit`
 * `COUNT`.
 */
export const webhooksNav: readonly NavItem[] = [
  {
    label: 'Webhooks',
    to: '/webhooks',
    icon: Webhook,
    group: 'operation',
    minimumPhase: 'in-certification',
    // Configuring outbound deliveries is administration: whoever invoices does not decide which systems get notified.
    minimumPermission: 'settings:write',
    children: [
      { label: 'Suscripciones', to: '/webhooks' },
      { label: 'Entregas fallidas', to: '/webhooks/deliveries' },
      { label: 'Historial de eventos', to: '/events' },
    ],
  },
];
